import React from 'react';
import ReactMarkdown from 'react-markdown';

const MarkdownMessage = ({ content }) => {
  return (
    <div className="prose-chat text-sm leading-relaxed">
      <ReactMarkdown
        components={{
          p: ({ children }) => <div className="mb-2 last:mb-0">{children}</div>,
          strong: ({ children }) => <strong className="font-semibold text-text-primary">{children}</strong>,
          em: ({ children }) => <em className="italic text-text-secondary">{children}</em>,
          ul: ({ children }) => <ul className="list-disc pl-4 mb-2 space-y-1">{children}</ul>,
          ol: ({ children }) => <ol className="list-decimal pl-4 mb-2 space-y-1">{children}</ol>,
          li: ({ children }) => <li className="text-text-primary">{children}</li>,
          h1: ({ children }) => <h1 className="text-lg font-bold text-text-primary mb-2 mt-3">{children}</h1>,
          h2: ({ children }) => <h2 className="text-base font-bold text-text-primary mb-2 mt-3">{children}</h2>,
          h3: ({ children }) => <h3 className="text-sm font-bold text-text-primary mb-1 mt-2">{children}</h3>,
          code: ({ inline, children }) =>
            inline
              ? <code className="bg-background px-1.5 py-0.5 rounded text-xs font-mono text-primary">{children}</code>
              : <pre className="bg-background border border-border rounded-lg p-3 mb-2 overflow-x-auto"><code className="text-xs font-mono text-text-primary">{children}</code></pre>,
          blockquote: ({ children }) => <blockquote className="border-l-2 border-primary/40 pl-3 my-2 text-text-secondary italic">{children}</blockquote>,
          hr: () => <hr className="border-border my-3" />,
          a: ({ href, children }) => <a href={href} target="_blank" rel="noopener noreferrer" className="text-primary underline hover:text-primary/80">{children}</a>,
          table: ({ children }) => <div className="overflow-x-auto mb-2"><table className="text-xs border-collapse">{children}</table></div>,
          th: ({ children }) => <th className="border border-border px-2 py-1 bg-background font-semibold text-left">{children}</th>,
          td: ({ children }) => <td className="border border-border px-2 py-1">{children}</td>,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownMessage;
